var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// ProtectedRoute.tsx
import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { getIsUserInAnyOfTheseRoles } from '../utils/auth/identity';
import Loader from './Loader';
const ProtectedRoute = (_a) => {
    var { component: Component, roles } = _a, rest = __rest(_a, ["component", "roles"]);
    const [isAuthorized, setIsAuthorized] = React.useState(null);
    useEffect(() => {
        const checkAuthorization = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const isLoggedIn = !!localStorage.getItem('token');
                if (!isLoggedIn) {
                    setIsAuthorized(false);
                    return;
                }
                const authorized = yield getIsUserInAnyOfTheseRoles(roles);
                setIsAuthorized(authorized);
            }
            catch (error) {
                console.error('Error checking user roles:', error);
                setIsAuthorized(false);
            }
        });
        checkAuthorization();
    }, [roles]);
    if (isAuthorized === null) {
        // Optionally, you can return a loading spinner or some placeholder here
        return React.createElement(Loader, null);
    }
    if (!isAuthorized) {
        return React.createElement(Navigate, { to: "/not-authorized" });
    }
    return React.createElement(Component, Object.assign({}, rest));
};
export default ProtectedRoute;
